export function removerAcentos(newStringComAcento) {
    let string = (newStringComAcento).toString();
    const mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g
    };

    for (const letra in mapaAcentosHex) {
        const expressaoRegular = mapaAcentosHex[letra];
        string = string.replace(expressaoRegular, letra);
    }

    return string;
}

export function parseUrl(url: string): any {
    url = url.replace(/^((?:.*)\?)/, '');
    let result = {};
    url.split('&').forEach(part => {
        let item = part.split('=');
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
}

export function getAppUrl() {
    const baseUrl = getCookie('baseUrl');
    return baseUrl;
}

export function parseResult(obj) {
    return JSON.parse(obj);
}

export function getCookie(cname) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        // tslint:disable-next-line:triple-equals
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        // tslint:disable-next-line:triple-equals
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
